import React from "react";
import { useSelector } from "react-redux";
import AuthView from "../../utils/AuthView";

/**
 * Wraps an Integrations sub-page (e.g. the Web Chat widget connect page). Opens for the account Owner, or a role given BOTH
 * Integrations.View and Integrations.Manage (Settings -> Roles & Permission); anyone else sees the standard "no access" view.
 * Renders nothing until the role and permissions have loaded, so there is no flash of "no access" on a page refresh.
 */
const IntegrationsManageGate = ({ children }) => {
  const roleName = useSelector((s) => s.userDetails.userDetails?.roleName);
  const permissions = useSelector((s) => s.userDetails.userPermissions?.permissions);

  if (!roleName || !permissions) return null;
  const allowed =
    roleName === "Owner" || (permissions.Integrations?.View === true && permissions.Integrations?.Manage === true);
  return allowed ? children : <AuthView />;
};

export default IntegrationsManageGate;
